import axios from 'src/api/Api';
import {
    GET_INVENTORY_DATA_SUCCESS,
    GET_INVENTORY_DATA_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getInventoryDetails(action) {
    const productType = action.payload ? encodeURIComponent(action.payload.productType) : '';
    const accountNumber = action.payload ? encodeURIComponent(action.payload.accountNumber) : '';
    const currentPage = action.payload ? encodeURIComponent(action.payload.currentPage) : '';
    const orderType = action.payload ? encodeURIComponent(action.payload.orderType) : '';
    const resourceType = action.payload ? encodeURIComponent(action.payload.resourceType) : '';
    const sortCode = action.payload ? encodeURIComponent(action.payload.sortCode) : '';
    const sortOrder = action.payload ? encodeURIComponent(action.payload.sortOrder) : '';
    const filterParam = action.payload ? encodeURIComponent(action.payload.filterParam) : '';
    const searchQuery = action.payload ? encodeURIComponent(action.payload.searchQuery) : '';
    const pageSize = action.payload ? encodeURIComponent(action.payload.pageSize) : '';
    const isBKPProductsDisplay = action.payload
        ? encodeURIComponent(action.payload.isBKPProductsDisplay)
        : false;
    try {
        const result = yield axios({
            method: 'get',
            url: `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/consignment/inventory?productType=${productType}&accountNumber=${accountNumber}&currentPage=${currentPage}&orderType=${orderType}&resourceType=${resourceType}&sortCode=${sortCode}&sortOrder=${sortOrder}&filterParam=${filterParam}&searchQuery=${searchQuery}&pageSize=${pageSize}&isBKPProductsDisplay=${isBKPProductsDisplay}`,
        }).then((response) => response.data);
        yield put({
            type: GET_INVENTORY_DATA_SUCCESS,
            payload: result,
        });
    } catch (e) {
        const url = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/consignment/inventory?productType=${productType}&accountNumber=${accountNumber}&currentPage=${currentPage}&orderType=${orderType}&resourceType=${resourceType}&sortCode=${sortCode}&sortOrder=${sortOrder}&filterParam=${filterParam}&searchQuery=${searchQuery}&pageSize=${pageSize}&isBKPProductsDisplay=${isBKPProductsDisplay}`;
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_INVENTORY_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
